export default !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/react-virtualized-select/node_modules/dom-helpers/esm/canUseDOM.js
// module id = 2616
// module chunks = 69